<script setup lang="ts">
import {CustomNodeProps, FlowchartActionType} from "@/core/interfaces/flowchart/flowchart";
import {ClipboardList, Phone, Pill, Printer} from "@lucide/vue";
import {computed, type Component} from "vue";

const props = defineProps<{
    data: CustomNodeProps
}>();

const actionChips: Record<FlowchartActionType | 'product', {icon: Component; label: string; class: string}> = {
    survey: {icon: ClipboardList, label: 'Questionnaire', class: 'bg-lightPurple-lightest text-primary'},
    print: {icon: Printer, label: 'Imprimer', class: 'bg-[#e6f6ff] text-[#1c93d6]'},
    contact: {icon: Phone, label: 'Contacter', class: 'bg-[#ffefdd] text-[#d97706]'},
    product: {icon: Pill, label: 'Voir les produits', class: 'bg-[#d8f7ec] text-[#2f9e7e]'}
};

/**
 * A print node whose documents all list the picked products is an advice sheet:
 * the pharmacist comes for the products, not for the paper.
 */
const isAdviceSheet = computed((): boolean => {
    return props.data.action_type === 'print'
        && props.data.action_payload.documents.every(document => document.requires_recommendations);
});

/**
 * The labeled action chip matching the node action type, if any.
 */
const actionChip = computed(() => {
    if (isAdviceSheet.value) {
        return actionChips.product;
    }

    return props.data.action_type ? actionChips[props.data.action_type] : null;
});
</script>

<template>
  <div
    v-if="data.description || actionChip"
    class="flex justify-between gap-2"
  >
    <div v-if="actionChip" class="flex justify-end">
      <span
        class="inline-flex h-[21px] items-center gap-1.5 rounded-full pl-2 pr-2.5 text-tiny font-semibold"
        :class="actionChip.class"
      >
        <component :is="actionChip.icon" class="size-2.5 shrink-0" />
        {{ actionChip.label }}
      </span>
    </div>
  </div>
</template>

<style scoped>

</style>
